import { getSenders } from 'api/TemplatePickerAPI';
import { setDefaultSender, createEmailSender, editSender, deleteSender } from 'api/SendersAPI';
import { addNegativeToast, addPositiveToast } from 'modules/toastContainer';
import { call, put, takeLatest } from 'redux-saga/effects';
import { addToRootSaga } from 'store';
import { fetchUserProjectRequest } from 'core/userContext/actions';
import * as actionTypes from './actionTypes';
import {
  fetchSendersError,
  fetchSendersResponse,
  setDefaultSenderRequest,
  createSenderRequest,
  editSenderRequest,
  fetchSenders,
  deleteAndReplaceSenderRequest,
} from './actions';

export function* fetchSendersSaga() {
  try {
    const { data } = yield call(getSenders);
    const { smsSenders, authedEmails, smsMessageTypes, smsEsps, validSendDomains } = data;
    yield put(
      fetchSendersResponse(smsSenders, authedEmails, smsMessageTypes, smsEsps, validSendDomains),
    );
  } catch (error) {
    yield put(addNegativeToast('Unable to fetch senders'));
    yield put(fetchSendersError());
  }
}

export function* setDefaultSenderSaga({
  defaultSender,
}: ReturnType<typeof setDefaultSenderRequest>) {
  try {
    yield call(setDefaultSender, defaultSender);
    yield put(addPositiveToast('Default sender successfully updated'));
    // the default sender state is kept in the user context,
    // so we need to refetch the user project in order to make sure everything
    // is up-to-date in the UX.
    yield put(fetchUserProjectRequest());
  } catch (error) {
    yield put(addNegativeToast('Unable to update default sender'));
  }
}

export function* createSenderSaga({ data }: ReturnType<typeof createSenderRequest>) {
  try {
    yield call(createEmailSender, data);
    yield put(addPositiveToast('Sender created successfully'));
    yield put(fetchSenders());
  } catch (error) {
    yield put(addNegativeToast('Unable to create sender'));
  }
}

export function* editSenderSaga({ sender }: ReturnType<typeof editSenderRequest>) {
  try {
    yield call(editSender, sender);
    yield put(addPositiveToast('Sender successfully updated'));
    yield put(fetchSenders());
  } catch (error) {
    yield put(addNegativeToast('Unable to update sender'));
  }
}

export function* deleteAndReplaceSenderSaga({
  deleteAndReplaceSender,
}: ReturnType<typeof deleteAndReplaceSenderRequest>) {
  try {
    yield call(deleteSender, deleteAndReplaceSender);
    yield put(addPositiveToast('Sender successfully deleted'));
    yield put(fetchSenders());
  } catch (error) {
    yield put(addNegativeToast('Unable to delete sender'));
  }
}

addToRootSaga([
  takeLatest(actionTypes.FETCH_SENDERS_REQUEST, fetchSendersSaga),
  takeLatest(actionTypes.SET_DEFAULT_SENDER_REQUEST, setDefaultSenderSaga),
  takeLatest(actionTypes.CREATE_SENDER_REQUEST, createSenderSaga),
  takeLatest(actionTypes.EDIT_SENDER_REQUEST, editSenderSaga),
  takeLatest(actionTypes.DELETE_SENDER_REQUEST, deleteAndReplaceSenderSaga),
]);
